

export const randomChoice = <T>(things: T[]): T => (
  things[Math.floor(Math.random() * things.length)]
)
